// firebase.js use to log signups
import { initializeApp , getApps} from "firebase/app";
import { getFirestore } from "firebase/firestore";
import KEYS from "../config/keys";

const firebaseConfig = {
  apiKey: KEYS.SIGNUP_FIREBASE_API_KEY,
  authDomain: KEYS.SIGNUP_FIREBASE_AUTH_DOMAIN,
  projectId: KEYS.SIGNUP_FIREBASE_PROJECT_ID,
  storageBucket: KEYS.SIGNUP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: KEYS.SIGNUP_FIREBASE_MESSAGING_SENDER_ID,
  appId: KEYS.SIGNUP_FIREBASE_APP_ID,
};



// Custom name for the Firebase app
const appName = "signupApp";

// Initialize Firebase if it hasn't been initialized already
const app = !getApps().some(app => app.name === appName)
  ? initializeApp(firebaseConfig, appName)
  : getApp(appName);


// Firestore Database
export const firebaseSignupDB = getFirestore(app);
